import { useSelector } from 'react-redux';
import { selectGlobalNavigationEnabled } from '~/components/brand/ducks/selectors';
import { useLocation } from 'react-router-dom';
import {
	ROUTE_HUB,
	ROUTE_FREE_TO_PLAY_CUSTOM,
	ROUTE_LIVEBETTING,
	ROUTE_PROMOTIONS,
	ROUTE_SHOP,
	ROUTE_SPLASH_TECH,
	ROUTE_SPORTSBOOK,
	ROUTE_THUNDERBITE,
	ROUTE_TVBET,
	ROUTE_VIRTUALS,
	ROUTE_WE_SPIN
} from '~/components/router/constants';
import { isNativeNavHeaderEnabled } from '~/components/app-bridge/app-properties';
import useCasinoRoutes from '~/components/router/use-casino-routes';
import { useMemo } from 'react';

const useDisplayGlobalNavigation = () => {
	const hasNativeNavHeader = isNativeNavHeaderEnabled();
	const isGlobalNavigationEnabled = useSelector(selectGlobalNavigationEnabled);
	const { ROUTE_CASINO, ROUTE_LIVE_CASINO } = useCasinoRoutes();
	const path = useLocation()?.pathname ?? '';
	const page = path.split('/')[1];
	const topNavigationRoutes = useMemo(
		() => [
			ROUTE_CASINO,
			ROUTE_LIVE_CASINO,
			ROUTE_SPORTSBOOK,
			ROUTE_LIVEBETTING,
			ROUTE_THUNDERBITE,
			ROUTE_SPLASH_TECH,
			ROUTE_WE_SPIN,
			ROUTE_TVBET,
			ROUTE_VIRTUALS,
			ROUTE_HUB,
			ROUTE_SHOP,
			ROUTE_PROMOTIONS,
			ROUTE_FREE_TO_PLAY_CUSTOM
		],
		[ROUTE_CASINO, ROUTE_LIVE_CASINO]
	);
	const displayGlobalNavigation =
		isGlobalNavigationEnabled && topNavigationRoutes.includes(`/${page}`) && !hasNativeNavHeader;
	return { displayGlobalNavigation };
};

export default useDisplayGlobalNavigation;
